/*
*
* To transform JSON response to our desirable response
*
* */
export default {
  prepareThen (response) {
    const res =  {
      code: response.status,
      errorCode: response.data.errorCode,
      errorMessage: response.data.errorMessage,
      data: response.data
    }
    return res
  },
  prepareValidationCatch (error) {
    return {
      code: error.response.status,
      errors: error.response.data.errors
    }
  },
  prepareGeneralCatch (error) {
    return {
      code: error.response.status,
      errorCode: error.response.data.errorCode,
      errorMessage: error.response.data.errorMessage
    }
  },
  prepareCatch (error) {
    if (error.response.status === 422) {
      return this.prepareValidationCatch(error)
    } else {
      return this.prepareGeneralCatch(error)
    }
  }
}
